import { render } from "./CatalogSectionRecents.vue?vue&type=template&id=65a0e632"
import script from "./CatalogSectionRecents.vue?vue&type=script&lang=js"
export * from "./CatalogSectionRecents.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__